<div class="header-container">
  <div class="logo-container">
    <a
      href="#"
      class="sidebar-toggle"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()"
    >
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
    <div *ngIf="!dev_environment"><img src="../../../assets/images/HappyLogo.png" alt="Happy Hotel Logo"/></div>

    <a class="logo" href="#" (click)="navigateHome()">{{dev_environment ? "[DEV] " : ""}}Admin Portal</a>
  </div>
</div>

  <div class="col-md-6" *ngIf="showFilter">

    <form [formGroup]="form">
      <div class="form-group">
        <div class="form-bg" [ngClass]="highlightBranch"></div>
        <!-- <div class="form-bg highlight" *ngIf="highlightBranch"></div> -->
        <mat-form-field class="example-full-width" appearance="fill">
          <input type="text" #branchInput (input)="_filter()" matInput [formControl]="branchFilter2" [matAutocomplete]="auto" (focus)="_filter()">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onBranchSelect($event)" [displayWith]="displayFn">
            <mat-option *ngFor="let branch of filteredOptions" [value]="branch">
              {{ branch.branchName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

      </div>
    </form>
  </div>
  
        <!-- <nb-select placeholder="{{placeHolderName}}" fullWidth hero status="primary" formControlName="branchFilter" [(selected)]="form.controls.branchFilter.value" (selectedChange)="onBranchSelect($event)">
          <nb-option *ngFor="let b of branchOptions" [value]="b.id">{{b.branchName}}</nb-option>
        </nb-select> -->

<div class="header-container">
  <nb-actions size="small">
    <nb-action
      class="user-action"
      *nbIsGranted="['view', 'user']"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.username"
               [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>

<ng-template #dialogRef let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Confirmation</nb-card-header>
    <nb-card-body>Are you sure you want to log out?</nb-card-body>
    <nb-card-footer>
      <button nbButton matRipple (click)="ref.close()">Cancel</button>
      <button nbButton matRipple (click)="logout()">Log out</button>
    </nb-card-footer>
  </nb-card>
</ng-template>